import React, { useEffect, useState } from "react";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, apiSuccessToast } from "../utils/ToastUtil";
import {
  FormControl,
  Grid,
  TextField,
  Typography,
  Button,
  Box,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";

const PartPaymentElectricity = () => {
  const [progress, setProgress] = useState(false);
  const [params, setParams] = useState([]);
  const [billerName, setBillerName] = useState("");
  const [billerId, setBillerId] = useState("");
  const [billersList, setBillersList] = useState([]);
  const [formData, setFormData] = useState({});

  const getBillersDetails = () => {
    setProgress(true);

    postJsonData(
      ApiEndpoints.BBPS_GET_BILLERS_DETAILS,
      { billerId: "TATAPWR00DEL01" },
      setProgress,
      (res) => {
        const data = res.data?.data || {};
        let updatedParams = data.parameters || [];
        setBillersList(true);
        if (!updatedParams.some((param) => param.desc === "Mobile Number")) {
          updatedParams.push({
            name: "mobileNumber",
            desc: "Mobile Number",
            minLength: 10,
            maxLength: 10,
            inputType: "NUMERIC",
            mandatory: 1,
            regex: "^[6-9]\\d{9}$",
          });
        }

        if (!updatedParams.some((param) => param.name === "amount")) {
          updatedParams.push({
            name: "amount",
            desc: "Amount",
            minLength: 2,
            maxLength: 7,
            inputType: "NUMERIC",
            mandatory: 1,
            regex: "^[0-9]+$",
          });
        }

        setParams(updatedParams);
        setBillerName(data.billerInfo?.name || "");

        setProgress(false);
      },
      (err) => {
        apiErrorToast(err);
        setProgress(false);
      }
    );
  };

  useEffect(() => {
    getBillersDetails();
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  console.log("the form data is ", formData);
  //   const handlePayment = () => {
  //     if (!formData.mobileNumber || !formData.amount) {
  //       apiErrorToast("Please enter mobile number and amount");
  //       return;
  //     }

  //     postJsonData(
  //       ApiEndpoints.PAY_ELECTRICITY_BILL,
  //       {
  //         billerId: "TATAPWR00DEL01",
  //         mobileNumber: formData.mobileNumber,
  //         amount: formData.amount,
  //         otherParams: formData,
  //       },
  //       setProgress,
  //       (res) => {
  //         apiSuccessToast("Payment successful!");
  //       },
  //       (err) => {
  //         apiErrorToast(err);
  //       }
  //     );
  //   };

  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#e0f0f1",
        border: "2px solid rgb(252, 216, 162)",
      }}
    >
      <Box
        sx={{
          p: 4,
          width: "90%",
          maxWidth: 500,
          borderRadius: "16px",
          border: "2px solid #14b8a6",
          bgcolor: "rgba(255, 255, 255, 0.8)",
          boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
          backdropFilter: "blur(10px)",
        }}
      >
        <Typography
          variant="h4"
          align="center"
          sx={{ fontWeight: "bold", color: "#0f766e", mb: 2 }}
        >
          Part Payment Electricity
        </Typography>

        <Grid item xs={6}>
          <Typography variant="subtitle1" fontWeight={500} color="#00796b">
            Select Provider
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Select
            fullWidth
            value={billerName}
            onChange={(e) => setBillerName(e.target.value)}
            displayEmpty
            variant="outlined"
          >

            <MenuItem value={billerName}>{billerName}</MenuItem>
          </Select>
        </Grid>
        
        {billerName && (
          <Grid container spacing={2} sx={{
            mt:1
          }}>
            {params.map((item, index) => (
              <Grid item xs={12} key={index}>
                <FormControl sx={{ width: "100%" }}>
                  <TextField
                    autoComplete="off"
                    label={item.desc}
                    id={item.name}
                    inputProps={{
                      minLength: item.minLength,
                      maxLength: item.maxLength,
                      pattern: item.regex,
                    }}
                    size="small"
                    required={item.mandatory === 1}
                    type={item.inputType === "NUMERIC" ? "number" : "text"}
                    value={formData[item.name] || ""}
                    onChange={handleChange}
                    sx={{
                      bgcolor: "#ffffff",
                      borderRadius: "8px",
                      "& label": { color: "#14b8a6" },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "#14b8a6" },
                        "&:hover fieldset": { borderColor: "#0d9488" },
                        "&.Mui-focused fieldset": { borderColor: "#0f766e" },
                      },
                    }}
                  />
                </FormControl>
              </Grid>
            ))}
            <Grid item xs={12}>
              <Button
                variant="contained"
                fullWidth
                sx={{
                  bgcolor: "#0f766e",
                  color: "#fff",
                  borderRadius: "8px",
                  fontSize: "1rem",
                  textTransform: "none",
                  "&:hover": { bgcolor: "#0d9488" },
                }}
              >
                Proceed to Pay
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default PartPaymentElectricity;
